import { Link } from 'react-router-dom';
import { useWhatsApp } from '../context/WhatsAppContext';
import { BananaLeaf, OrnateDivider } from './KeralaDecor';
import site from '../data/site';
import './Footer.css';

export default function Footer() {
  const { open } = useWhatsApp();
  return (
    <footer className="ft">
      <BananaLeaf position="top-left" size={220} opacity={0.18} />
      <BananaLeaf position="top-right" size={220} opacity={0.18} mirror />

      <div className="container ft__inner">
        <div className="ft__grid">
          <div className="ft__col ft__brand">
            <span className="eyebrow-script ft__welcome">Welcome to</span>
            <h3 className="ft__title">H2 FRESH</h3>
            <p className="ft__sub">Kerala Restaurant & Halal Meat Market</p>
            <p className="ft__tag">{site.servingSince}</p>
          </div>

          <div className="ft__col">
            <h4>Visit</h4>
            <p>
              <a href={site.address.mapsUrl} target="_blank" rel="noopener noreferrer">
                {site.address.line1}<br/>{site.address.line2}
              </a>
            </p>
            {site.phones.map((p) => (
              <p key={p.tel}><a href={`tel:${p.tel}`}>{p.display}</a></p>
            ))}
          </div>

          <div className="ft__col">
            <h4>Hours</h4>
            <p className="ft__hours-line">{site.hours.summary}</p>
            <p className="ft__hours-closed">{site.hours.closedNote}</p>
            <p className="ft__hours-applies">Restaurant + Market, same hours</p>
          </div>

          <div className="ft__col">
            <h4>Connect</h4>
            <button onClick={open} className="btn btn-whatsapp ft__wa">
              📱 Join WhatsApp
            </button>
            <p className="ft__connect-note">
              Daily specials, fresh-cut alerts, weekend menus.
            </p>
            <ul className="ft__quick">
              <li><Link to="/menu">Our Menu</Link></li>
              <li><Link to="/market">The Market</Link></li>
              <li><Link to="/contact">Contact & Map</Link></li>
            </ul>
          </div>
        </div>

        <OrnateDivider className="ft__divider" />

        <div className="ft__bottom">
          <p>{site.copyright}</p>
          <p className="ft__bottom-tag">Hand-cut · Zabiha · Family-owned</p>
        </div>
      </div>
    </footer>
  );
}
